import SectionHeading from "@/components/SectionHeading";
import Reveal from "@/components/Reveal";
import FaqAccordion from "@/components/FaqAccordion";
import { useJsonLd } from "@/hooks/useJsonLd";

const FaqSection = ({ title, items, dark = false, idPrefix = "faq", eyebrow = "FAQs", withSchema = true }) => {
  useJsonLd(
    "faq-jsonld",
    withSchema &&
      items && {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: items.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      }
  );

  if (!items || items.length === 0) return null;

  return (
    <section
      data-testid={`${idPrefix}-section`}
      className={dark ? "bg-navy" : "bg-mist text-navy dot-grid-light"}
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20 lg:py-32">
        <SectionHeading dark={dark} eyebrow={eyebrow} title={title} />
        <Reveal className="mt-12">
          <FaqAccordion items={items} dark={dark} idPrefix={idPrefix} />
        </Reveal>
      </div>
    </section>
  );
};

export default FaqSection;
